/* Zeepy — Bedtime Stories library
   Cards are already in the DOM (rendered by Liquid). This only:
   filters them, collapses the list to a limit, syncs state to the URL, and
   runs one audio player at a time.

   It never creates or removes a card — every episode stays in the page source
   so Google sees all of them. Both the filter and the "view all" collapse are
   show/hide only. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.zbsReady) return;
    root.dataset.zbsReady = '1';

    var cards   = Array.prototype.slice.call(root.querySelectorAll('.zbs-card'));
    var pills   = Array.prototype.slice.call(root.querySelectorAll('.zbs-pill'));
    var jumps   = Array.prototype.slice.call(root.querySelectorAll('[data-jump]'));
    var grid    = root.querySelector('.zbs-cards');
    var empty   = root.querySelector('.zbs-empty');
    var count   = root.querySelector('.zbs-count');
    var freeEl  = root.querySelector('.zbs-freecount');
    var library = root.querySelector('.zbs-library');
    var moreWrap = root.querySelector('.zbs-more');
    var moreBtn  = root.querySelector('.zbs-more-btn');
    var total   = cards.length;

    var limit = parseInt(root.dataset.limit, 10);
    if (!limit || limit < 1) limit = 6;

    var defaults = {
      type: root.dataset.defaultType || 'all',
      phase: root.dataset.defaultPhase || 'all'
    };
    var state = { type: defaults.type, phase: defaults.phase };
    var expanded = false;

    var audio = null, current = null;

    /* ---------- audio: one at a time, never autoplay ---------- */
    function stopAll() {
      if (audio) { audio.pause(); audio.src = ''; audio = null; }
      current = null;
      root.querySelectorAll('.zbs-play').forEach(function (b) {
        b.classList.remove('is-playing');
        b.querySelector('.zbs-icon').innerHTML = '&#9654;';
      });
      root.querySelectorAll('.zbs-fill').forEach(function (f) { f.style.width = '0'; });
      root.querySelectorAll('.zbs-elapsed').forEach(function (e) { e.textContent = '0:00'; });
      root.querySelectorAll('.zbs-bar').forEach(function (b) { b.setAttribute('aria-valuenow', '0'); });
    }

    function mmss(s) {
      s = Math.max(0, Math.floor(s || 0));
      return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0');
    }

    function wirePlayer(card) {
      var btn = card.querySelector('.zbs-play');
      if (!btn) return;
      var fill = card.querySelector('.zbs-fill');
      var el   = card.querySelector('.zbs-elapsed');
      var bar  = card.querySelector('.zbs-bar');

      btn.addEventListener('click', function () {
        if (current === btn) { stopAll(); return; }
        stopAll();
        audio = new Audio(btn.dataset.audio);
        audio.preload = 'none';
        var p = audio.play();
        if (p && p.catch) p.catch(function () { stopAll(); });
        current = btn;
        btn.classList.add('is-playing');
        btn.querySelector('.zbs-icon').innerHTML = '&#10074;&#10074;';

        audio.addEventListener('timeupdate', function () {
          if (!audio || !audio.duration) return;
          var pct = (audio.currentTime / audio.duration) * 100;
          fill.style.width = pct + '%';
          el.textContent = mmss(audio.currentTime);
          bar.setAttribute('aria-valuenow', Math.round(pct));
        });
        audio.addEventListener('ended', stopAll);
        audio.addEventListener('error', stopAll);
      });

      function seekTo(ratio) {
        if (current !== btn || !audio || !audio.duration) return;
        audio.currentTime = Math.min(1, Math.max(0, ratio)) * audio.duration;
      }
      bar.addEventListener('click', function (e) {
        var r = bar.getBoundingClientRect();
        seekTo((e.clientX - r.left) / r.width);
      });
      bar.addEventListener('keydown', function (e) {
        if (current !== btn || !audio || !audio.duration) return;
        if (e.key === 'ArrowRight') { audio.currentTime += 10; e.preventDefault(); }
        if (e.key === 'ArrowLeft')  { audio.currentTime -= 10; e.preventDefault(); }
      });
    }
    cards.forEach(wirePlayer);

    /* ---------- filtering + collapsing ---------- */
    function apply(push) {
      var matching = 0, visible = 0, free = 0;

      cards.forEach(function (c) {
        var ok = (state.type === 'all' || c.dataset.type === state.type) &&
                 (state.phase === 'all' || c.dataset.phase === state.phase);

        if (ok) {
          matching++;
          if (c.dataset.free === 'true') free++;
        }

        /* Two reasons to hide: filtered out, or past the limit while collapsed.
           Both are the `hidden` attribute — the card never leaves the DOM. */
        var show = ok && (expanded || visible < limit);
        if (show) visible++;
        c.hidden = !show;
      });

      if (empty) empty.hidden = matching !== 0;
      if (grid)  grid.style.display = matching ? '' : 'none';

      if (count) {
        /* "all" means all of what's on screen, not all that match — otherwise
           the collapsed default reads "Showing all 68" while showing six. */
        count.textContent = visible === matching
          ? 'Showing all ' + matching + ' pieces'
          : 'Showing ' + visible + ' of ' + matching + ' pieces';
      }
      if (freeEl) freeEl.textContent = free ? free + ' free to play here' : '';

      /* The button only exists when there is something behind it. */
      if (moreWrap && moreBtn) {
        var canExpand = matching > limit;
        moreWrap.hidden = !canExpand;
        if (canExpand) {
          var moreLabel = (moreBtn.dataset.more || 'View all') + ' ' + matching;
          moreBtn.textContent = expanded ? (moreBtn.dataset.less || 'Show fewer') : moreLabel;
          moreBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        }
      }

      pills.forEach(function (p) {
        var on = state[p.dataset.k] === p.dataset.v;
        p.classList.toggle('is-on', on);
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      if (push) {
        var q = new URLSearchParams(window.location.search);
        /* Only carry a param when it differs from the section's own default,
           so the tidy URL is the default view rather than "no filter". */
        state.type === defaults.type ? q.delete('type') : q.set('type', state.type);
        state.phase === defaults.phase ? q.delete('phase') : q.set('phase', state.phase);
        var s = q.toString();
        try {
          history.pushState({ zbs: true }, '', s ? '?' + s : window.location.pathname);
        } catch (e) {}
      }
    }

    function readURL() {
      var q = new URLSearchParams(window.location.search);
      state.type  = q.get('type')  || defaults.type;
      state.phase = q.get('phase') || defaults.phase;
    }

    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        stopAll();
        state[p.dataset.k] = p.dataset.v;
        expanded = false; /* a new filter starts collapsed again */
        apply(true);
      });
    });

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        expanded = !expanded;
        apply(false);
        if (!expanded && library) {
          library.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    jumps.forEach(function (b) {
      b.addEventListener('click', function () {
        stopAll();
        state.phase = b.dataset.jump;
        expanded = false;
        apply(true);
        if (library) library.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    window.addEventListener('popstate', function () {
      readURL();
      expanded = false;
      apply(false);
    });

    readURL();
    apply(false);
  }

  function boot() {
    document.querySelectorAll('.zbs').forEach(init);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot)
    : boot();

  /* re-init when the theme editor re-renders the section */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.zbs');
    if (el) init(el);
  });
})();
